 import { Injectable } from '@angular/core';
import {Http} from '@angular/http';
import {Constants} from '../../util/Constants';
import {Router} from '@angular/router';

@Injectable()
export class AuthService {

  constructor(public http: Http, public router: Router) {
  }
// make auth
  public auth(authPayload: any){
    return this.http.post(Constants.LOGIN_URL + '?username=' + authPayload.username + '&password='
      + authPayload.password, Constants.getRequestHeader()).
      map(res => res.json());
  }
// get user profile data
  public getProfile(token: string) {
    return this.http.get(Constants.PROFILE_URL, Constants.getRequestOption(token))
      .map(res => res.json());
  }
// reset password
  public resetPassword(email: string) {
    return this.http.get(Constants.RESET_PASSWORD_URL + '?email=' + email, Constants.getRequestHeader())
      .map(res => res.json());
  }
// create password
  createPassword(password: any) {
    return this.http.put(Constants.CREATE_PASSWORD_URL, password,  Constants.getRequestHeader())
  }
// create roles
  createRoles(rolesPayload: any) {
    return this.http.post(Constants.CREATE_ROLES_URL, rolesPayload,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }
// update roles
  updateRoles(rolesPayload: any, id: number) {
    return this.http.put(Constants.UPDATE_ROLES_URL + id, rolesPayload,
      Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }
// create super agent

  createAgent(agentData: any, formData) {
    let payload = '';
    for (let key in agentData){
      if (agentData.hasOwnProperty(key)){
        payload += '' + key + '=' + agentData[key] + '&';
      }
    }

    payload = payload.replace(/&+$/g, ''); // remove the trailing &
    // console.log("******* payload ********");
    // console.log(payload);
    return this.http.post(Constants.CREATE_AGENT_URL + payload, formData, Constants.getMultipartRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  changePassword(passwordPayload: any) {
    return this.http.put(Constants.CHANGE_PASSWORD_URL, passwordPayload, Constants.getRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }

  // multiple user by uploading sheet
  createMultipleUser(roleId: any, formData: FormData) {
    return this.http.post(Constants.UPLOAD_USER_DATA_URL + '?roleId=' + roleId, formData, Constants.getMultipartRequestOption(localStorage.getItem(Constants.ACCESS_TOKEN)))
      .map(res => res.json());
  }


// refresh token
  refreshToken() {
    return this.http.get(Constants.REFRESH_TOKEN_URL, Constants.getRefreshTokenRequestOption(localStorage.getItem(Constants.REFRESH_TOKEN)))
      .map(res => res.json());
  }
// save access and refresh token to local storage
  saveToken(accessToken: string, refreshToken: string) {
    localStorage.setItem(Constants.REFRESH_TOKEN, refreshToken);
    localStorage.setItem(Constants.ACCESS_TOKEN,  accessToken);
  }
// save user profile to local stirage
  saveProfile(profileData: any){
    localStorage.setItem(Constants.PROFILE, profileData);
  }
// logout service
  logout() {
    localStorage.clear();
    this.router.navigate([Constants.SIGNIN_URL]);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/auth-service/auth-service.service.ts